import { render, staticRenderFns } from "./ViberCampaignCreateSecondStep.vue?vue&type=template&id=28a2b7a9&scoped=true&"
import script from "./ViberCampaignCreateSecondStep.vue?vue&type=script&lang=js&"
export * from "./ViberCampaignCreateSecondStep.vue?vue&type=script&lang=js&"
import style0 from "./ViberCampaignCreateSecondStep.vue?vue&type=style&index=0&id=28a2b7a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a2b7a9",
  null
  
)

export default component.exports